var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "action",
    transform: "translate(-293 -159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8983",
    "data-name": "Rectangle 8983",
    width: 22,
    height: 22,
    rx: 5,
    transform: "translate(293 159)",
    fill: "#7f8fa4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "action-2",
    "data-name": "action",
    transform: "translate(295.5 160.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40850",
    "data-name": "Path 40850",
    d: "M0,0H15V15H0Z",
    transform: "translate(1 2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40851",
    "data-name": "Path 40851",
    d: "M15.557,6.057,11.935,2.435A1.5,1.5,0,0,0,10.878,2H5.5A1.5,1.5,0,0,0,4.008,3.5L4,15.5A1.5,1.5,0,0,0,5.492,17H14.5A1.5,1.5,0,0,0,16,15.5V7.123A1.5,1.5,0,0,0,15.557,6.057Zm-6.885,7.41-1.59-1.59a.747.747,0,0,1,0-1.057h0a.747.747,0,0,1,1.058,0L9.2,11.878l2.655-2.655a.747.747,0,0,1,1.058,0h0a.747.747,0,0,1,0,1.057L9.73,13.46A.74.74,0,0,1,8.673,13.468ZM11.5,7.25a.752.752,0,0,1-.75-.75V3.125L14.875,7.25Z",
    transform: "translate(-1.5)",
    fill: "#7f8fa4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.0967099f07061fc8f58bc96ffef8cce9.svg";
export { ForwardRef as ReactComponent };